import scrollReveal from "scrollreveal";
export default function() {
    const scroll = scrollReveal();
    scroll.reveal(".reveal-top", {
        // 动画的时长
        duration: 1000,
        // 延迟时间
        delay: 300,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "top",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "100px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear",
        scale: 0.9,
    });
    scroll.reveal(".reveal-right", {
        // 动画的时长
        duration: 1000,
        // 延迟时间
        delay: 300,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "right",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "100px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear",
        scale: 0.9,
    });
    scroll.reveal(".reveal-left", {
        // 动画的时长
        duration: 600,
        // 延迟时间
        delay: 300,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "left",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "100px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear",
        scale: 0.9,
    });
    scroll.reveal(".reveal-bottom", {
        // 动画的时长
        duration: 700,
        // 延迟时间
        delay: 300,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "100px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear",
        scale: 1,
    });
    scroll.reveal(".reveal-opacity", {
        // 动画的时长
        duration: 600,
        // 延迟时间
        delay: 300,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "0px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear",
        scale: 1,
    });
    scroll.reveal(".reveal-scale", {
        // 动画的时长
        duration: 1000,
        // 延迟时间
        delay: 300,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "0px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear",
        scale: 0.6,
    });
}



// WEBPACK FOOTER //
// ./src/Pages/animation.js